import { ChittravanLogoMark } from "@/components/marketing/logo-mark";
import { cn } from "@/utils/ui";

/** The Chitravan signature: tree-and-camera mark + lowercase display wordmark. One place, one look. */
export function Wordmark({
	size = 22,
	className,
	showText = true,
}: {
	size?: number;
	className?: string;
	showText?: boolean;
}) {
	return (
		<span className={cn("inline-flex items-center gap-2", className)}>
			<ChittravanLogoMark size={size} />
			{showText && (
				<span className="font-display text-[1.05rem] font-semibold leading-none tracking-tight text-foreground">
					chitravan
				</span>
			)}
		</span>
	);
}
